import React, { useContext } from 'react'
import { CardBody } from 'reactstrap'
import { Dropdowns } from "../../../AbstractElements"
import { MoreVertical } from 'react-feather'
import useFetchUserRoles from '../../../hook'
import { isWriteAccess } from '../../../utils/adminRoles'
import CourseModal from './CourseModal'
import { showAlert } from '../../../utils/alert';
import { toast } from 'react-toastify'
import AdminContext from '../../../Helper/admin'
import { addAdminActivity, deleteDoc } from '../../../firebase/utils'
import { capitalizeFirstLetter } from '../../../utils/text'


const CourseAction = ({ data, showModal, courses, setCourses }) => {
  const hasWriteAccess = useFetchUserRoles("courses", isWriteAccess);
  const { user, location } = useContext(AdminContext)

  const deleteCourse = async (course) => {
    const warningText = `Are you sure you want to delete ${course?.name} ${capitalizeFirstLetter(course?.type)} course?`
    const isConfirm = await showAlert(warningText)
    if(isConfirm){
      const activityOptions = {
        adminId: user.email,
        type: 'delete_course',
        createdAt: new Date(),
        courseName: course.name,
        courseType: course.type,
        courseId: course.id,
        activity: `${user.email} deleted course ${course.name} ${course.type}`,
      };
      await addAdminActivity(activityOptions, location)
      await deleteDoc('courses', course.id)
      setCourses(courses.filter((cor) => cor.id !== course.id))
      toast.success("Course deleted successfully");
    }
  };

  const action = [
    {
      item: `${data.paymentDetail ? 'Edit' : 'Add'} Payment Details`,
      onClick: () => hasWriteAccess ? showModal('COURSE_PAYMENT', data) : toast.error("You don't have access, please ask Super Admin to provide you access!")
    },
    {
      item: 'Edit',
      onClick: () => hasWriteAccess ? showModal('EDIT_COURSE', data) : toast.error("You don't have access, please ask Super Admin to provide you access!")
    },
    {
      item: 'Duplicate',
      onClick: () => hasWriteAccess ? showModal('DEPLICATE_COURSE', data) : toast.error("You don't have access, please ask Super Admin to provide you access!")
    },
    {
      item: 'Delete',
      onClick: () => hasWriteAccess ? deleteCourse(data) : toast.error("You don't have access, please ask Super Admin to provide you access!")
    },
  ]

  return (
    <div>
      <CardBody className="dropdown-basic p-0 fee-table-action">
        <Dropdowns
          attrDropBtn={{ className: 'dropbtn table-action' }}
          attrDropMenu={{ className: 'dropdown-content module-dropdown' }}
          dropItem={action}
          dropBtnContent={<MoreVertical className="dropbtn" />}
          attrDropItem={{
            toggle: false,
          }}
        />
      </CardBody>
    </div>
  )
}

export default CourseAction